import { render, staticRenderFns } from "./FreshworksHelpBtn.vue?vue&type=template&id=7c95cf1b&scoped=true&"
import script from "./FreshworksHelpBtn.vue?vue&type=script&lang=js&"
export * from "./FreshworksHelpBtn.vue?vue&type=script&lang=js&"
import style0 from "./FreshworksHelpBtn.vue?vue&type=style&index=0&id=7c95cf1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c95cf1b",
  null
  
)

export default component.exports